( function($) {
    
    
    // ****************** Sticky Nav On Scroll **********************************************//	
    function stickyNav() {
    jQuery(window).scroll(function () {
        if (jQuery(window).scrollTop() > 20) {
            jQuery("#masthead").addClass('sticky');
        } else {
            jQuery("#masthead").removeClass('sticky');
        }
    });
    }

  $(document).ready( function() {
      
      function pageFadeIn() { 
    $('#layout').hide().fadeIn(1500);
}
	  
	 document.querySelectorAll('textarea.g-recaptcha-response').forEach(function(field) {
    if (!field.hasAttribute('aria-label')) {
        field.setAttribute('aria-label', 'reCAPTCHA response');
    }
});
     
  
// ****************** Mobile Nav  ***************************************************************************//   
jQuery(function ($) {
  const mobileQuery = window.matchMedia('(max-width: 1199.98px)');
  const $nav = $('.main-nav');
  const $hamburger = $('.hamburger');
  const $closeButton = $('.close-nav');

  function setMenuOpen(open, returnFocus = false) {
    $nav.toggleClass('active', open);
    $('body').toggleClass('menu-open', open);

    $hamburger
      .attr('aria-expanded', String(open))
      .attr('aria-label', open ? 'Close menu' : 'Open menu');

    if (!open && returnFocus) {
      $hamburger.trigger('focus');
    }
  }

  function getSubmenu($button) {
    return $button.next('.sub-menu');
  }

  function setSubmenuOpen($button, open) {
    const $submenu = getSubmenu($button);

    if (!$submenu.length) {
      return;
    }

    const menuName = $button
      .siblings('a')
      .first()
      .text()
      .trim();

    $button
      .attr('aria-expanded', String(open))
      .attr(
        'aria-label',
        `${open ? 'Hide' : 'Show'} ${menuName} submenu`
      );

    $button.closest('li').toggleClass('active', open);

    // Only use the hidden attribute on mobile.
    if (mobileQuery.matches) {
      $submenu.prop('hidden', !open);
    }
  }

  function resetForViewport() {
    $('.main-nav-list .submenu-toggle').each(function () {
      const $button = $(this);
      const $submenu = getSubmenu($button);

      $button.attr('aria-expanded', 'false');
      $button.closest('li').removeClass('active');

      if (mobileQuery.matches) {
        // Mobile starts closed.
        $submenu.prop('hidden', true);
      } else {
        // Desktop CSS controls submenu visibility through hover/focus.
        $submenu.prop('hidden', false);
      }
    });

    if (!mobileQuery.matches) {
      setMenuOpen(false);
    }
  }

  $hamburger.on('click', function () {
    setMenuOpen(!$nav.hasClass('active'));
  });

  $closeButton.on('click', function () {
    setMenuOpen(false, true);
  });

  $(document).on('click', '.main-nav-list .submenu-toggle', function (event) {
    event.preventDefault();
    event.stopPropagation();

    const $button = $(this);
    const open = $button.attr('aria-expanded') !== 'true';

    setSubmenuOpen($button, open);
  });

  $(document).on('keydown', function (event) {
    if (event.key === 'Escape' && mobileQuery.matches && $nav.hasClass('active')) {
      setMenuOpen(false, true);
    }
  });

  mobileQuery.addEventListener('change', resetForViewport);

  resetForViewport();
});

// ****************** Lock Map Area  ***************************************************************************//   
function toTop() {
    if ($('.up-btn').length>0) {
        var scroll;
        $(window).on('scroll', function(){
            scroll = $(window).scrollTop();
            if (scroll>101) {
                $('.up-btn').addClass('show-up');
            } else {
                $('.up-btn').removeClass('show-up');
            }
        })


        $('.up-btn').on('click', function(){
            $('html, body').animate({
                scrollTop: 0
            }, 600);
        });
    }
}

// ****************** Scroll to section on mobile  ***********************************************************//   
function scrolltotabMobile() {
$('.tabs.tab-faqs .tab-labels a').on('click', function(e) {

	if (window.innerWidth <= 767) {

		const target = $(this).attr('href');

		if ($(target).length) {

			setTimeout(function() {

				$('html, body').animate({
					scrollTop: $(target).offset().top - 20
				}, 400);

			}, 50);

		}

	}

});
}	  
       
/*===> Tabs ====================================================================================================*/
function tabs () {
        jQuery('.tabs').tabslet({
            active: 1,
            animation: true
        });
    }
    
/*===> Accordions ===============================================================================================*/
function accordions() {
    const headers = document.querySelectorAll('.accordion-header');

    function removeResizeHandling(content) {
        if (content._resizeObserver) {
            content._resizeObserver.disconnect();
            content._resizeObserver = null;
        }

        if (content._setHeight) {
            window.removeEventListener('resize', content._setHeight);
            content._setHeight = null;
        }
    }

    function closeAccordion(header) {
        const content = header.nextElementSibling;

        header.classList.remove('active');
        header.setAttribute('aria-expanded', 'false');

        removeResizeHandling(content);

        content.style.maxHeight = '0px';
        content.classList.remove('active');

        const hideContent = function (event) {
            if (
                event.target === content &&
                event.propertyName === 'max-height' &&
                header.getAttribute('aria-expanded') === 'false'
            ) {
                content.hidden = true;
            }
        };

        content.addEventListener('transitionend', hideContent, { once: true });
    }

    function openAccordion(header) {
        const content = header.nextElementSibling;

        header.classList.add('active');
        header.setAttribute('aria-expanded', 'true');

        content.hidden = false;
        content.classList.add('active');

        const setHeight = () => {
            if (content.classList.contains('active')) {
                content.style.maxHeight = content.scrollHeight + 'px';
            }
        };

        content._setHeight = setHeight;

        requestAnimationFrame(setHeight);

        if (document.fonts) {
            document.fonts.ready.then(setHeight);
        }

        window.addEventListener('resize', setHeight);

        if ('ResizeObserver' in window) {
            const resizeObserver = new ResizeObserver(setHeight);

            resizeObserver.observe(content);
            content._resizeObserver = resizeObserver;
        }
    }

    headers.forEach((header) => {
        const content = header.nextElementSibling;
        const isOpen = header.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
            content.hidden = false;
            content.classList.add('active');

            requestAnimationFrame(() => {
                content.style.maxHeight = content.scrollHeight + 'px';
            });
        } else {
            content.hidden = true;
            content.style.maxHeight = '0px';
        }

        header.addEventListener('click', () => {
            const isOpen = header.getAttribute('aria-expanded') === 'true';

            if (isOpen) {
                closeAccordion(header);
                return;
            }

            headers.forEach((item) => {
                if (item !== header) {
                    closeAccordion(item);
                }
            });

            openAccordion(header);
        });
    });
}
	  
// ****************** Lock Map Area  ***************************************************************************//   
function LockMap(){
jQuery('#lock-map-area').bind('click', function (event) {
    event.preventDefault();

    if (jQuery('#lock-map-area').hasClass('collapsed')) {
        jQuery('#lock-map-area').removeClass('collapsed');
        jQuery('#lock-map-area a').text('Tap to unlock');
    } else {
        jQuery('#lock-map-area').addClass('collapsed');
        jQuery('#lock-map-area a').text('Tap to lock');
    }

});
}
	  
// ****************** Colir Contrast  ***************************************************************************//   
function colorContrast() {
  jQuery('.color-contrast').on('click', function () {
    const $button = jQuery(this);
    const $targets = jQuery('.block-accessible, .theme-btn, .page-header');
    const enabled = $button.attr('aria-pressed') !== 'true';

    $targets.toggleClass('accessible', enabled);

    $button
      .attr('aria-pressed', String(enabled))
      .attr(
        'aria-label',
        enabled ? 'Disable high contrast' : 'Enable high contrast'
      )
      .toggleClass('active-btn', enabled);
  });
}
	  
// ****************** Sliders  *************************************************************************••••••**//   
function heroSlider() {
  const $slider = jQuery('.hero-slider');

  if (!$slider.length) {
    return;
  }

  new Swiper('.hero-slider', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,

    loop: false,
    speed: 500,

    navigation: {
      nextEl: '.hero-slider .swiper-button-next',
      prevEl: '.hero-slider .swiper-button-prev',
    },

    pagination: {
      el: '.hero-slider .swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return `
          <button
            type="button"
            class="${className}"
            aria-label="Show slide ${index + 1}">
          </button>
        `;
      },
    },

    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },

    a11y: {
      enabled: true,
      prevSlideMessage: 'Show previous slide',
      nextSlideMessage: 'Show next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Show slide {{index}}',
    },
  });
}  
	  
function expand_content() {
    const bioWraps = document.querySelectorAll('.bio-wrap');
    const collapsedHeight = 220;

    bioWraps.forEach(function (wrap) {
        const bio = wrap.querySelector('.bio');
        const button = wrap.querySelector('.bio-read-more');

        if (!bio || !button) {
            return;
        }

        const readMoreText = button.querySelector('.read-more-text');
        const readLessText = button.querySelector('.read-less-text');
        const icon = button.querySelector('.toggle-icon');

        if (bio.scrollHeight <= collapsedHeight) {
            button.remove();
            bio.style.maxHeight = 'none';
            return;
        }

        bio.style.maxHeight = collapsedHeight + 'px';

        button.addEventListener('click', function () {
            const isExpanded = wrap.classList.contains('is-expanded');

            if (isExpanded) {
                bio.style.maxHeight = collapsedHeight + 'px';
                wrap.classList.remove('is-expanded');
                button.setAttribute('aria-expanded', 'false');

                if (readMoreText) readMoreText.hidden = false;
                if (readLessText) readLessText.hidden = true;
                if (icon) icon.textContent = '+';

            } else {
                bio.style.maxHeight = bio.scrollHeight + 'px';
                wrap.classList.add('is-expanded');
                button.setAttribute('aria-expanded', 'true');

                if (readMoreText) readMoreText.hidden = true;
                if (readLessText) readLessText.hidden = false;
                if (icon) icon.textContent = '−';
            }
        });
    });
}
    
function initEvents() {
  
jQuery(function() {
	    heroSlider();
	    expand_content();
        toTop();
	    colorContrast();
        accordions();
        tabs();
        LockMap();
	    scrolltotabMobile()
        stickyNav();
	 AOS.init({
            once: true
        });
    });
}

/*Start all functions and actions*/
initEvents()
          });

    
})(jQuery);





